export enum OnboardStepEnum {
  NotStarted = 0,
  Account = 1,
  Company = 2,
  Property = 3,
  EVSE = 4,
  BuildingPerformance = 5,
  UtilityConnection = 6,
  Summary = 7,
}

export enum OnboardSubstepEnum {
  AccountSetup = 1,
  AccountVerification = 2,
  AccountPassword = 3,
  Company = 4,
  Property = 5,
  EVSE = 6,
  BuildingPerformance = 11,
  UtilityConnection = 7,
  UtilityEntryManual = 8,
  UtilityConfirmation = 9,
  Summary = 10,
}
